<template>
  <div class="score-index-entry">
    <el-dialog
      title="科目分数指标"
      :visible.sync="scoreIndexEntryShow"
      width="60%"
      :before-close="dialogClose"
      @open="dialogOpen"
    >
      <div style="margin-bottom: 20px">
        选择年级：
        <el-select
          v-model="selectGradeId"
          placeholder="选择年级"
          @change="scoreIndexEntryGradeChange"
        >
          <el-option
            :label="item.gradeName"
            :value="item.gradeId"
            v-for="item in gradeList"
            :key="item.gradeId"
          ></el-option>
        </el-select>
      </div>
      <el-tabs @tab-click="courseTabsChange" v-model="currentCourseName">
        <el-tab-pane
          v-for="item in schoolCourseList"
          :key="item.courseId"
          :label="item.courseName"
          :name="item.courseName"
        >
          <el-table
            :data="item.descriptors"
            border
            style="width: 100%; max-height: 400px; overflow-y: auto"
          >
            <el-table-column prop="desc" label="名称" width="180">
              <template slot-scope="{ row }">
                <el-input v-model="row.desc" />
              </template>
            </el-table-column>
            <el-table-column prop="minScore" label="分数区间-最小" width="180">
              <template slot-scope="{ row }">
                <el-input v-model.number="row.minScore" />
              </template>
            </el-table-column>
            <el-table-column prop="maxScore" label="分数区间-最大" width="150">
              <template slot-scope="{ row }">
                <el-input v-model.number="row.maxScore" />
              </template>
            </el-table-column>
            <el-table-column prop="externalShow" label="对外评定">
              <template slot-scope="{ row }">
                <el-input v-model="row.externalShow" />
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="btn-list">
        <el-button type="primary" @click="scoreIndexAdd">添加指标</el-button>
        <el-button type="primary" plain @click="scoreIndexDel"
          >删除指标</el-button
        >
        <el-button type="primary" @click="confirm">保存</el-button>
        <el-button type="primary" plain @click="dialogClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["scoreIndexEntryShow", "schoolCourseList", "gradeList"],
  data() {
    return {
      currentCourseName: "", // 当前选中的标签名称
      selectGradeId: "", // 选择的年级
    };
  },
  methods: {
    scoreIndexEntryGradeChange(e) {
      this.$emit("scoreIndexEntryGradeChange", e);
    },
    // 切换顶部标签
    courseTabsChange(e) {
      // console.log("切换的顶部标签：", e.label);
      let currentCourseDescriptorList = this.schoolCourseList.find(
        (item) => item.courseName === this.currentCourseName
      ).descriptors;
      // 切换时去除之前包含空属性的输入行
      this.removeEmptyValues(currentCourseDescriptorList);
    },
    // 删除对象数组中属性值为空的对象
    removeEmptyValues(courseList) {
      for (let i = courseList.length - 1; i >= 0; i--) {
        const course = courseList[i];
        for (const key in course) {
          if (typeof course[key] !== "number") {
            if (course.hasOwnProperty(key) && !course[key]) {
              // 删除属性值为空的对象
              courseList.splice(i, 1);
              break;
            }
          }
        }
      }
    },
    // 检测对象数组中是否有属性值为空
    checkEmptyValues(courseList) {
      for (const course of courseList) {
        for (const key in course) {
          if (typeof course[key] !== "number") {
            if (course.hasOwnProperty(key) && !course[key]) {
              return false;
            }
          }
        }
      }
      return true;
    },
    // 科目分制添加一条数据
    scoreIndexAdd() {
      let currentCourseDescriptorList = this.schoolCourseList.find(
        (item) => item.courseName === this.currentCourseName
      ).descriptors;
      currentCourseDescriptorList.push({
        desc: "",
        minScore: "",
        maxScore: "",
        externalShow: "",
      });

      // console.log("this.schoolCourseList:", this.schoolCourseList);
    },
    // 科目分制删除一条数据
    scoreIndexDel() {
      let currentCourseDescriptorList = this.schoolCourseList.find(
        (item) => item.courseName === this.currentCourseName
      ).descriptors;
      currentCourseDescriptorList.pop();
    },
    // 科目分数指标录入点击确定
    confirm() {
      // console.log("科目分数指标录入点击确定");
      let currentCourseData = this.schoolCourseList.find(
        (item) => item.courseName === this.currentCourseName
      );
      let isEmpty = this.checkEmptyValues(currentCourseData.descriptors);
      if (!isEmpty) {
        return this.$message.warning("请补充完整指标信息");
      }
      let data = {
        courseId: currentCourseData.courseId,
        descriptors: currentCourseData.descriptors,
        gradeId: this.selectGradeId
      };
      this.$emit("scoreIndexEntryConfirm", data);
    },
    dialogOpen() {
      // 默认选中第一个科目信息
      this.currentCourseName = this.schoolCourseList[0].courseName;
      this.selectGradeId = this.gradeList[0].gradeId;
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:scoreIndexEntryShow", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./scoreIndexEntryDialog.scss";
</style>